import {Select} from "../../../shared/Select/Select";
import React from "react";
import './Filters.scss';
import {Legend} from "../Legend/Legend";

export type FilterData = {
    data: Array<string>,
    label: string,
    key: string,
    active: Array<string>
}

type FilterProps = {
    data: Array<FilterData>,
    setFilters: (key: string, values: string[]) => void,
    open?: boolean
}
const Filters = ({data, setFilters, open = false}: FilterProps) => {

    return (
        <div className={'filter-wrapper'}>
            <div className={'filter-section filter-section--open'}>
                {data.map(({data, label, key, active}, i) => (
                    <Select data={data}
                            key={i}
                            label={label}
                            current={active}
                            onChange={(values) => setFilters(key, values)}/>
                ))}
            </div>
            <Legend data={data}/>
        </div>
    )
}

export {Filters}